export default "__VITE_ASSET__892d3d78__"